export default "__VITE_PUBLIC_ASSET__cc76e011__"